import React from "react";
import {
  InnerNavigator,
  InnerNavigatorOption,
} from "components/ui/InnerNavigator";

type LayoutProps = {
  children: React.ReactNode;
  page?: string;
  options?: InnerNavigatorOption[];
};

export const NavigatorLayout: React.FC<LayoutProps> = ({ children, options }) => {
  return (
    <section className="min-w-0 max-w-full p-4">
      {options && <InnerNavigator options={options} />}
      <section className="min-w-0 max-w-full py-6">{children}</section>
    </section>
  );
};
